function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9401 24.2471H26.7467L30.6125 0.425034H36.816L32.9401 24.2471Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5249 0.425034L15.6149 16.8091L14.9166 13.2772L12.832 2.57044C12.832 2.57044 12.579 0.425034 9.88708 0.425034H0.111318L0 0.829827C0 0.829827 2.98535 1.44714 6.48682 3.55206L11.8706 24.2471H18.327L28.1939 0.435153H21.5249V0.425034Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M70.3025 24.2471H76L71.0312 0.425034H66.0421C63.7449 0.425034 63.1782 2.19601 63.1782 2.19601L53.9286 24.237H60.3952L61.6905 20.6951H69.5739L70.3025 24.2471ZM63.4716 15.8173L66.7302 6.90173L68.5619 15.8173H63.4716Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M54.4144 6.15286L55.2948 1.04234C55.2948 1.04234 52.5625 0 49.7188 0C46.6525 0 39.3358 1.34594 39.3358 7.88336C39.3358 14.0362 47.9175 14.1172 47.9175 17.3454C47.9175 20.5736 40.2264 19.9968 37.6863 17.9627L36.7654 23.306C36.7654 23.306 39.5382 24.6519 43.7683 24.6519C47.9984 24.6519 54.384 22.4559 54.384 16.4953C54.384 10.302 45.7316 9.72517 45.7316 7.03329C45.7215 4.34141 51.763 4.68549 54.4144 6.15286Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9166 13.2772L12.832 2.57044C12.832 2.57044 12.579 0.425034 9.88708 0.425034H0.111318L0 0.829827C0 0.829827 4.69561 1.80133 9.19893 5.45459C13.51 8.93582 14.9166 13.2772 14.9166 13.2772Z",
  fill: "currentColor"
});

function SvgIconVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 76 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon-visa.1f13179e.svg";
export { ForwardRef as ReactComponent };